import { render } from "./newUserRole.vue?vue&type=template&id=1e9f5554"
import script from "./newUserRole.vue?vue&type=script&lang=js"
export * from "./newUserRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__